import React, { useMemo } from 'react'
import './table.css'
import numeral from 'numeral'
import { MaterialReactTable } from 'material-react-table';
import { Container } from '@mui/material';

const Table = ({ countries }) => {
    const columns = useMemo(
        () => [
            {
                accessorKey: 'cases', //access nested data with dot notation
                header: 'Activecase',
                size: 150,
            },
            {
                accessorKey: 'country',
                header: 'Country',
                size: 150,
            },
        ],
        [],
    );


    return (
        <>
            <div className="table">
                {countries.map((currdata) => (
                    <tr>
                        <td>{currdata?.country}</td>
                        <td><strong>{numeral(currdata?.cases).format("0,0")}</strong></td>
                    </tr>
                ))}
            </div>


        </>

    )
}

export default Table